module.exports = __webpack_public_path__ + "static/profcast-image-4304a17b2dfff73a85ec4837f023aae0.jpg";